import React, { useRef } from "react";
import ExtraSVGIcons from "../elements/other_svgs";
import Button from "../elements/Buttons";
 
const ExtraButtons = ({ actionHistory, actionMenu, language, disableBack, messageCount, isLanguageBtn, languageAction, isServiceBusy }) => {
  const generateRef = useRef(null);
  const menuRef = useRef(null);
  let backBtnName = language === "ar" ? "الرجوع للخلف" : "Back";
  let menuBtnName = language === "ar" ? "القائمة الرئيسية" : "Main Menu";
  const handleActionHistory=(e)=>{
    e.stopPropagation();
    if (generateRef.current) {
      generateRef.current.click();
    } 
  }
  
  const handleMenuButton=(e)=>{
    e.stopPropagation();
    if (menuRef.current) {
      menuRef.current.click();
    }  
  }   
 
  return (
    <div className="area-extras">
      <button style={{cursor:"pointer"}} disabled={disableBack || messageCount <= 1} title={backBtnName} onClick={handleActionHistory} type="button">
        <ExtraSVGIcons title={backBtnName} color={"#ffffff"} size={15} type="historyBack" />
      </button>
      <button style={{cursor:"pointer"}} disabled={disableBack || messageCount <= 1} title={menuBtnName} onClick={handleMenuButton} type="button">
        <ExtraSVGIcons title={menuBtnName} color={"#ffffff"} size={15} type="listMenu" />
      </button>
      <button ref={generateRef} title={backBtnName} onClick={actionHistory} type="button" style={{display:"none"}}>
        {backBtnName}
      </button>
      <button ref={menuRef} title={menuBtnName} onClick={actionHistory} type="button" style={{display:"none"}}>
        {menuBtnName}
      </button>
      {isLanguageBtn && isLanguageBtn===true?(
        language==='ar'?(
            <Button
                id="langEnBtn"
                type="button"
                classes="languageBtn"
                title="English"
                action={languageAction}
                areaLabel="English"
                svg="false"
                disabled={isServiceBusy}
            >
                English
            </Button>
        ):(
            <Button
                id="langArBtn"
                type="button"
                classes="languageBtn"
                title="العربية"
                action={languageAction}
                areaLabel="العربية"
                svg="false"
                disabled={isServiceBusy}
            >
                عربي
            </Button>
        )                            
    ):(null)}
    </div>
  );
};
 
export default ExtraButtons;